import { render, staticRenderFns } from "./TrafficList.vue?vue&type=template&id=36f87134"
import script from "./TrafficList.vue?vue&type=script&lang=js"
export * from "./TrafficList.vue?vue&type=script&lang=js"
import style0 from "./TrafficList.vue?vue&type=style&index=0&id=36f87134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports